import { styled } from '@mui/material';
import { PropsWithChildren, ComponentProps } from 'react';
import Button from './Button';

const MenuButton = styled(Button)(({ theme }) => ({
  '&.Mui-disabled svg path': {
    fill: theme.palette.grey[300]
  },
  backgroundColor: theme.palette.grey[400],
  minWidth: 'auto'
}));

export const TableMenuButton = (props: PropsWithChildren<ComponentProps<typeof MenuButton>>) => (
  <MenuButton color={'secondary'} variant="contained" startIconHeight={24} startIconWidth={24} {...props} />
);
